import React, { useEffect, useRef, useState } from "react";
import "./Home.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchHomeData } from "../../redux/HomePageSlice";
import { useVisibilityOnScroll } from "../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import HeroHomeAr from "../../Component/HeroHome/HeroHomeAr";
import ResponsiveBoxImgTPB from "../../Component/ReuseComponent/BoxImgTPB/BoxImgTPB";
import { Link } from "react-router-dom";

import HomeS2PBImg from "../../Assets/Svg/Home/HomeS2PBImg.svg";
import HomeS3P1ImgL from "../../Assets/webp/Home/HomeS3P1ImgL.webp";
import HomeS3P1ImgLMob from "../../Assets/images/Home/HomeS3P1ImgLMob.webp";
import HomeS3P1ImgC from "../../Assets/images/Home/HomeS3P1ImgC.webp";
import HomeS3P1ImgCMob from "../../Assets/images/Home/HomeS3P1ImgCMob.webp";
import HomeS3P1ImgR from "../../Assets/webp/Home/HomeS3P1ImgR.webp";
import HomeS3P1ImgRMob from "../../Assets/images/Home/HomeS3P1ImgRMob.webp";
import HomeS3P3Img from "../../Assets/webp/Home/HomeS3P3ImgNew3.webp";
import HomeS3P3ImgMob from "../../Assets/webp/Home/HomeS3P3ImgMob.webp";
import HomeS4P2LBrand from "../../Assets/Svg/Milkman/MMS1Img.svg";
import HomeS4P2RBrand from "../../Assets/Svg/Home/HomeS4P2RBrand.svg";
import HomeS5BG from "../../Assets/webp/Home/HomeS5BGAr.webp";
import HomeS5BGMob from "../../Assets/webp/Home/HomeS5BGMob.webp";
import TC3L from "../../Component/ReuseComponent/TCLines/TC3L";
import HomeS2Active from "../../Assets/Svg/Home/HomeS2Active.svg";
import HomeS2NotActive from "../../Assets/Svg/Home/HomeS2NotActive.svg";
import { LoaderWrap } from "../../Component/GlobalLoader/LoaderWrap";

export default function HomeArContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.homePage);

  useEffect(() => {
    if (!data || data.length === 0) {
      dispatch(fetchHomeData({ lang: "ar" }));
    }
  }, [dispatch, data]);

  const section2 = data.find((s) => s.section_id === 2);
  const section3 = data.find((s) => s.section_id === 3);
  const section4 = data.find((s) => s.section_id === 4);
  const section5 = data.find((s) => s.section_id === 5);
  const section6 = data.find((s) => s.section_id === 6);
  return (
    <LoaderWrap>
      <div className="HomeContainer">
        <section className="HomeS1">
          <HeroHomeAr />
        </section>
        <div className="HomeRC">
          <section>
            <HomeS2 section2={section2} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="HomeS3">
            <HomeS3 section3={section3} />
          </VisibilitySection>
          <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="HomeS4">
            <HomeS4 section4={section4} />
          </VisibilitySection>
          <VisibilitySection index={3} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="HomeS5">
            <HomeS5 section5={section5} />
          </VisibilitySection>
          <VisibilitySection index={4} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="HomeS6">
            <HomeS6 section6={section6} />
          </VisibilitySection>
        </div>
      </div>
    </LoaderWrap>
  );
}

function HomeS2({ section2 }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const sliderIntervalRef = useRef(null);

  // Function to start/restart the slider interval
  const startSliderInterval = () => {
    if (sliderIntervalRef.current) {
      clearInterval(sliderIntervalRef.current);
    }
    sliderIntervalRef.current = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % section2?.contents?.length);
    }, 10000);
  };

  // Start the interval on component mount
  useEffect(() => {
    startSliderInterval();
    return () => clearInterval(sliderIntervalRef.current);
  }, [section2?.contents?.length]);

  // Handle manual dragging
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].clientX);
    clearInterval(sliderIntervalRef.current); // Stop interval while dragging
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;

    const diff = e.touches[0].clientX - startX;
    if (diff > 50) {
      setActiveIndex((prevIndex) => (prevIndex === 0 ? section2?.contents?.length - 1 : prevIndex - 1));
      setIsDragging(false);
      startSliderInterval();
    } else if (diff < -50) {
      setActiveIndex((prevIndex) => (prevIndex + 1) % section2?.contents?.length);
      setIsDragging(false);
      startSliderInterval();
    }
  };

  const activeImage = HomeS2Active;
  const nonActiveImage = HomeS2NotActive;
  return (
    <>
      <div className="HomeS2Container">
        <div className="HomeS2P1">
          <TC3L Title={section2?.title} />
        </div>
        {/* For Web */}
        <div className="HomeS2P2">
          {section2?.contents?.map((box, index) => (
            <ResponsiveBoxImgTPB
              key={index}
              ImgSrc={box.image[0]}
              ImgAlt={box.ImgAlt}
              Heading={box.title}
              Paragraph={box.description}
              ButtonText={box.button_text}
              ButtonImg={HomeS2PBImg}
              ButtonLink={box.button_link}
              TopHeight={index === 0 ? "47%" : index === 1 ? "40%" : "40%"}
              HeadArFont={"Marhey"}
              ArFont={"rubik"}
            />
          ))}
        </div>
        {/* For Mobile */}
        <div className="HomeS2P2_Mob">
          <div className="HomeS2P2_Mob_P1" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove}>
            {section2?.contents?.map((box, index) => (
              <div key={index} className={`slider-item ${index === activeIndex ? "active" : ""}`} style={{ display: index === activeIndex ? "block" : "none" }}>
                <ResponsiveBoxImgTPB
                  ImgSrc={box.image[0]}
                  ImgAlt=""
                  Heading={box.title}
                  Paragraph={box.description}
                  ButtonText={box.button_text}
                  ButtonImg={HomeS2PBImg}
                  ButtonLink={box.button_link}
                  TopHeight={index === 0 ? "47%" : index === 1 ? "40%" : "40%"}
                  HeadArFont={"Marhey"}
                  ArFont={"rubik"}
                />
              </div>
            ))}
          </div>

          <div className="HomeS2P2_Mob_P2">
            {section2?.contents?.map((_, index) => (
              <img key={index} src={index === activeIndex ? activeImage : nonActiveImage} alt="" className={index === activeIndex ? "active" : "non-active"} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
function HomeS3({ section3 }) {
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div>
        <div className="HomeS3">
          <div className="HomeS3P1">
            <img src={isMobile ? HomeS3P1ImgLMob : HomeS3P1ImgL} alt="" className="HomeS3P1ImgRNew" loading="lazy" />
            <img src={isMobile ? HomeS3P1ImgCMob : HomeS3P1ImgC} alt="" className="HomeS3P1ImgRNew HomeS3P1ImgCTop" loading="lazy" />
            <img src={isMobile ? HomeS3P1ImgRMob : HomeS3P1ImgR} alt="" className="HomeS3P1ImgRNew" loading="lazy" />
          </div>
          {/*  */}
          <div className="HomeS3P2">
            <TC3L
              // Head="التزامنا برعاية الأبقار"
              Title={section3?.title}
              Para={section3?.description}
              ParaWidth="55vw"
            />
          </div>
          {/*  */}
          <div className="HomeS3P3 HomeS3P3Ar">
            <div className="HomeS3P3P">
              <Link to={section3?.button_link + "/ar" || "#"} dir="rtl">
                {section3?.button_text}
                <img src={HomeS2PBImg} alt="" className="HomeS2PBImg" style={{ rotate: "180deg" }} loading="lazy" />
              </Link>
              <img src={isMobile ? HomeS3P3ImgMob : HomeS3P3Img} alt="" className="HomeS3P3Img" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function HomeS4({ section4 }) {
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    if (isMobile) {
      // Mobile-specific useEffect
      const handleMobileScroll = () => {
        const section4Top = document.querySelector(".HomeS4");
        const section4Bottom = document.querySelector(".HomeS4P2R");

        // Configuration for image
        const imageConfigsTop = [
          { selector: ".HomeS4MML1", initialBottom: -10, finalBottom: 5, maxProgress: 1 },
          { selector: ".HomeS4MML2", initialBottom: -30, finalBottom: -20, maxProgress: 1 },
          { selector: ".HomeS4MML3", initialBottom: -15, finalBottom: -7, maxProgress: 1.3 },
          { selector: ".HomeS4MML4", initialBottom: -15, finalBottom: -7, maxProgress: 1 },
          { selector: ".HomeS4MML5", initialBottom: -45, finalBottom: -20, maxProgress: 1 },
        ];

        const imageConfigsBottom = [
          { selector: ".HomeS4MMR1", initialBottom: -25, finalBottom: -15, maxProgress: 1 },
          { selector: ".HomeS4MMR2", initialBottom: -25, finalBottom: -11, maxProgress: 1 },
          { selector: ".HomeS4MMR3", initialBottom: -28, finalBottom: -18, maxProgress: 1 },
          { selector: ".HomeS4MMR4", initialBottom: -32, finalBottom: -22, maxProgress: 1 },
        ];

        if (section4Top) {
          const sectionTop = section4Top.getBoundingClientRect().top;
          const sectionHeight = section4Top.offsetHeight;
          const viewportHeight = window.innerHeight;

          if (sectionTop < viewportHeight && sectionTop > -sectionHeight) {
            imageConfigsTop.forEach((config) => {
              const img = document.querySelector(config.selector);
              if (img) {
                const progress = Math.min(Math.max((viewportHeight - sectionTop) / viewportHeight, 0.2), config.maxProgress);
                const interpolatedBottom = config.initialBottom + progress * (config.finalBottom - config.initialBottom);
                img.style.bottom = `${interpolatedBottom}vw`;
              }
            });
          }
        }

        if (section4Bottom) {
          const sectionTop = section4Bottom.getBoundingClientRect().top;
          const sectionHeight = section4Bottom.offsetHeight;
          const viewportHeight = window.innerHeight;

          if (sectionTop < viewportHeight && sectionTop > -sectionHeight) {
            imageConfigsBottom.forEach((config) => {
              const img = document.querySelector(config.selector);
              if (img) {
                const progress = Math.min(Math.max((viewportHeight - sectionTop) / viewportHeight, 0.2), config.maxProgress);
                const interpolatedBottom = config.initialBottom + progress * (config.finalBottom - config.initialBottom);
                img.style.bottom = `${interpolatedBottom}vw`;
              }
            });
          }
        }
      };

      window.addEventListener("scroll", handleMobileScroll);
      return () => window.removeEventListener("scroll", handleMobileScroll);
    } else {
      // Web-specific useEffect
      const handleScroll = () => {
        const section4 = document.querySelector(".HomeS4");

        // Configuration for image
        const imageConfigs = [
          { selector: ".HomeS4MML1", initialBottom: -10, finalBottom: 2.7, maxProgress: 1 },
          { selector: ".HomeS4MML2", initialBottom: -20, finalBottom: -10, maxProgress: 1 },
          { selector: ".HomeS4MML3", initialBottom: -10, finalBottom: -3.5, maxProgress: 1.3 },
          { selector: ".HomeS4MML4", initialBottom: -10, finalBottom: -2.5, maxProgress: 1 },
          { selector: ".HomeS4MML5", initialBottom: -15, finalBottom: -6, maxProgress: 1 },
          { selector: ".HomeS4MMR1", initialBottom: -15, finalBottom: -7.5, maxProgress: 1 },
          { selector: ".HomeS4MMR2", initialBottom: -13, finalBottom: -6.5, maxProgress: 1 },
          { selector: ".HomeS4MMR3", initialBottom: -13, finalBottom: -8.4, maxProgress: 1 },
          { selector: ".HomeS4MMR4", initialBottom: -15, finalBottom: -9, maxProgress: 1 },
        ];

        if (section4) {
          const sectionTop = section4.getBoundingClientRect().top;
          const sectionHeight = section4.offsetHeight;
          const viewportHeight = window.innerHeight;

          if (sectionTop < viewportHeight && sectionTop > -sectionHeight) {
            imageConfigs.forEach((config) => {
              const img = document.querySelector(config.selector);
              if (img) {
                const progress = Math.min(Math.max((viewportHeight - sectionTop) / viewportHeight, 0.2), config.maxProgress);
                const interpolatedBottom = config.initialBottom + progress * (config.finalBottom - config.initialBottom);
                img.style.bottom = `${interpolatedBottom}vw`;
              }
            });
          }
        }
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [isMobile]);

  return (
    <div className="HomeS4">
      <div className="HomeS4P1">
        <TC3L
          // Head="منتجاتنا"
          Title={section4?.title}
          Para={section4?.description}
          ParaWidth="40vw"
        />
      </div>
      <div className="HomeS4P2">
        {section4?.contents?.[0] && (
          <Link to={section4.contents[0].button_link + "/ar"}>
            <div className="HomeS4P2L">
              <img src={HomeS4P2LBrand} alt="" className="HomeS4P2LBrand" />
              <div className="HomeS4P2LImgesContainer">
                {section4.contents[0].image?.map((img, i) => (
                  <img key={i} src={img} alt="" className={`HomeS4MML${i + 1}`} />
                ))}
              </div>
            </div>
          </Link>
        )}
        {/*  */}
        {section4?.contents?.[1] && (
          <Link to={section4.contents[1].button_link + "/ar"}>
            <div className="HomeS4P2R">
              <img src={HomeS4P2RBrand} alt="" className="HomeS4P2RBrand" />
              <div className="HomeS4P2RImgesContainer">
                {section4.contents[1].image?.map((img, i) => (
                  <img key={i} src={img} alt="" className={`HomeS4MMR${i + 1}`} />
                ))}
              </div>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}

function HomeS5({ section5 }) {
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div className="HomeS5">
        <div className="HomeS5P1">
          <img src={isMobile ? HomeS5BGMob : HomeS5BG} alt="" className="HomeS5Bg" loading="lazy" />
        </div>
        <div className="HomeS5P2Ar">
          <TC3L
            // Head="وصفات"
            Title={section5?.title}
            TitleWidth={isMobile ? "30vw" : ""}
            TitleWidthMob="45vw"
            Para={section5?.description}
            ParaWidth="40vw"
            ParaWidthMob="60vw"
            Color="#fff"
            TextAlign="right"
            alignItems="flex-end"
          />
        </div>
        <div className="HomeS5P2BAr TFut16PxPCUC">
          <Link to={section5?.button_link + "/ar" || "#"} dir="rtl">
            {section5?.button_text}
            <img src={HomeS2PBImg} alt="" className="HomeS2PBImg" style={{ rotate: "180deg" }} loading="lazy" />
          </Link>
        </div>
      </div>
    </>
  );
}

function HomeS6({ section6 }) {
  return (
    <>
      <div className="HomeS6">
        <div className="HomeS6P1">
          <TC3L
            // Head="رحلة المنتجات"
            Title="من عائلتنا إلى عائلتك"
          />
        </div>
        <div className="HomeS6P2Container">
          {/* Box 1 */}
          {section6?.contents?.map((item, index) => (
            <HomeS6Box
              key={item.id || index}
              ImgSrc={item.image?.[0]}
              ImgAlt={item.title}
              Title={item.title}
              RouteText={item.button_text}
              RouteTo={item.button_link + "/ar"}
            />
          ))}
          {/*  */}
        </div>
      </div>
    </>
  );
}

function HomeS6Box({ ImgSrc, ImgAlt, Title, RouteTo, RouteText }) {
  return (
    <>
      <div className="HomeS6P2">
        <div className="HomeS6P2B">
          <img src={ImgSrc} alt={ImgAlt} className="HomeS6P2BImg" loading="lazy" />
          <div className="HomeS6P2BTAr TGLo32PxPC">{Title}</div>
          <div className="HomeS6P2BLAr TFut16PxPCUC">
            <Link to={RouteTo} dir="rtl">
              {RouteText}
              <img src={HomeS2PBImg} alt="" className="HomeS2PBImgAr" style={{ rotate: "180deg" }} loading="lazy" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
